import { TextField, InputAdornment, Autocomplete, Tab, Button } from "@mui/material"
import { Search } from "@mui/icons-material"

export default function SearchFilter({
    eventStatusOptions = [],
    onSearchInputChange = () => { },
    onFilterChange = () => { },
    activeTab,
    setActiveTab = () => { },
    onShareFeedbackClick = () => { }
}) {
    return (
        <div className="my-event-booking-search-filter">
            <div className="my-event-booking-search-filter-wrapper">

                <div className="event-booking-past-upcoming-events">
                    <div className="event-booking-tabs">
                        <Tab
                            label="Upcoming Events"
                            variant={activeTab === 'upcoming' ? "main" : "inactive"}
                            onClick={() => setActiveTab('upcoming')}
                        />
                        <Tab
                            label="Active Events"
                            variant={activeTab === 'active' ? "main" : "inactive"}
                            onClick={() => setActiveTab('active')}
                        />
                        <Tab
                            label="Past Events"
                            variant={activeTab === 'past' ? "main" : "inactive"}
                            onClick={() => setActiveTab('past')}
                        />
                    </div>

                    <Button
                        variant="lightToggleActiveSm"
                        disableTouchRipple
                        onClick={onShareFeedbackClick}
                        sx={{ lineHeight: '1.9' }}
                    >
                        Ratings & Reviews
                    </Button>
                </div>

                <div className="event-booking-search-filter">
                    <div className="event-booking-searchbar">
                        <TextField
                            placeholder="Search your bookings..."
                            fullWidth
                            slotProps={{ input: { startAdornment: <SearchIcon /> } }}
                            onChange={(e) => onSearchInputChange(e.target.value)}
                        />
                    </div>

                    <div className="event-booking-filters-container">
                        {/* <Button
                            variant="lightToggleActiveSm"
                            disableTouchRipple
                            onClick={onShareFeedbackClick}
                        >
                            Share Feedback
                        </Button> */}

                        {activeTab === 'past' && (
                            <Autocomplete
                                options={eventStatusOptions}
                                getOptionLabel={(option) => option.label}
                                onChange={(e, newValue) => onFilterChange(newValue?.value)}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Event Status"
                                        fullWidth
                                    />
                                )}
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        minWidth: '220px'
                                    }
                                }}
                            />
                        )}
                    </div>
                </div>

            </div>
        </div>
    )
}

function SearchIcon() {
    return (
        <InputAdornment position="start">
            <Search sx={{ color: 'var(--quaternary-color)' }} />
        </InputAdornment>
    );
}